import * as wagmiChains from 'wagmi/chains';
import { IWeb3ChainType } from '../type';
import btc from './btc';
import solana from './solana';
import ton from './ton';

const tomoEVMChains: IWeb3ChainType[] = Object.values(wagmiChains).map(item => {
  const chain: IWeb3ChainType = {
    chain: item,
    type: 'EVM',
    name: item.name,
    networkType: undefined,
    icon: undefined,
  };
  return chain;
});

const tomoChains = [btc, solana, ton, ...tomoEVMChains];

export { tomoEVMChains, tomoChains, btc, solana, ton };
